var _rect, _circle, _circle2, _g, _path, _path2, _g2, _path3, _g3, _g4, _path4, _path5, _g5, _g6, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgK3Round1M(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    rx: 30,
    fill: "url(#paint0_linear_55_16028)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "url(#paint1_linear_55_16028)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55_16028",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 88,
    height: 88
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "url(#paint2_linear_55_16028)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55_16028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 52L18.5 48L15.5 31L36 23L40 24L58.5 19.5L103.5 55L105 54L98 61.5L65 98L20.5 61.5L24 52Z",
    fill: "#D36806"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 55H7L12 61L9 55Z",
    fill: "#F4DE6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7663 4.70488L37.007 5.55658C36.6383 5.64012 36.4864 6.08248 36.726 6.37492C36.8417 6.51609 37.0241 6.58445 37.2041 6.55406L41.0049 5.9122C41.5099 5.82691 41.696 5.198 41.3185 4.85168C41.1697 4.71511 40.9633 4.66025 40.7663 4.70488Z",
    fill: "#72FBBF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_55_16028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0797 22.7411C21.505 10.8848 36.4348 6.64816 48.1299 13.3626L57.7742 18.8995C67.1876 24.304 70.5719 36.2303 65.4002 45.7735L57.9644 59.4944C52.61 69.3748 40.1685 72.9053 30.4225 67.3099L21.4541 62.161C9.6874 55.4054 5.457 40.4975 11.9217 28.5685L15.0797 22.7411Z",
    fill: "#FFE2C7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_55_16028",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 10,
    width: 60,
    height: 60
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0804 22.7411C21.5057 10.8848 36.4356 6.64816 48.1307 13.3626L57.775 18.8995C67.1883 24.304 70.5726 36.2303 65.4009 45.7735L57.9651 59.4944C52.6107 69.3748 40.1692 72.9053 30.4233 67.3099L21.4548 62.161C9.68813 55.4054 5.45773 40.4975 11.9224 28.5685L15.0804 22.7411Z",
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_55_16028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3003 45.1166C16.1003 42.7166 9.63363 47.1166 7.30029 49.6166L8.80029 25.1162L16.8003 11.6162L37.3003 7.11621L52.8003 13.1162C54.8003 14.2829 58.6003 17.6162 57.8003 21.6162C56.8003 26.6162 55.3003 31.1162 50.3003 40.1162C46.3003 47.3162 44.967 59.4495 44.8003 64.6162C40.3003 53.6162 32.3003 48.1166 23.3003 45.1166Z",
    fill: "#EEC59F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8506 23.1661C21.4508 10.9871 36.6957 6.49666 48.844 13.1534L52.0172 14.8921C56.1596 17.162 57.8424 22.248 55.8713 26.5406L51.8506 35.2964C46.6974 46.5188 33.0201 50.8936 22.3107 44.745L18.7023 42.6734C12.5836 39.1605 10.3838 31.4084 13.7455 25.2053L14.8506 23.1661Z",
    fill: "url(#paint3_linear_55_16028)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_55_16028)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2996 17.6162C36.2996 19.5492 34.7326 21.1162 32.7996 21.1162C30.8666 21.1162 29.2996 19.5492 29.2996 17.6162C29.2996 15.6832 30.8666 14.1162 32.7996 14.1162C34.7326 14.1162 36.2996 15.6832 36.2996 17.6162ZM38.2996 27.1162C38.2996 29.3253 36.5087 31.1162 34.2996 31.1162C32.0904 31.1162 30.2996 29.3253 30.2996 27.1162C30.2996 24.9071 32.0904 23.1162 34.2996 23.1162C36.5087 23.1162 38.2996 24.9071 38.2996 27.1162ZM35.7996 42.1162C38.2848 42.1162 40.2996 40.1015 40.2996 37.6162C40.2996 35.1309 38.2848 33.1162 35.7996 33.1162C33.3143 33.1162 31.2996 35.1309 31.2996 37.6162C31.2996 40.1015 33.3143 42.1162 35.7996 42.1162Z",
    fill: "#FF9735"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3205 49.6162C68.5383 46.0264 76.489 48.1567 80.0789 54.3745L83.5789 60.4367C87.1687 66.6545 85.0383 74.6052 78.8205 78.1951L68.4282 84.195C64.6019 86.4042 59.7092 85.0932 57.5 81.2668L50.5 69.1425C47.4625 63.8813 49.2651 57.1538 54.5263 54.1162L62.3205 49.6162Z",
    fill: "url(#paint4_linear_55_16028)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_55_16028",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 47,
    width: 37,
    height: 39
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3213 49.6162C68.5391 46.0264 76.4897 48.1567 80.0796 54.3745L83.5796 60.4367C87.1694 66.6545 85.0391 74.6052 78.8213 78.1951L68.429 84.195C64.6026 86.4042 59.7099 85.0932 57.5007 81.2668L50.5007 69.1425C47.4632 63.8813 49.2658 57.1538 54.527 54.1162L62.3213 49.6162Z",
    fill: "#D9D9D9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_55_16028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.5019 68.1162C55.3019 61.7162 55.3352 54.1162 56.0019 51.1162L60.0015 44.6162H67.5015L76.5015 46.1162C78.0015 47.4495 81.1015 50.2162 81.5015 50.6162C81.9015 51.0162 85.0015 56.1162 86.5015 58.6162L92.0015 66.1162L85.0015 74.6162C85.3348 71.7829 84.1015 66.8162 76.5015 69.6162C68.9015 72.4162 64.0015 78.4495 62.5015 81.1162C62.9015 74.3162 61.3351 69.6162 60.5019 68.1162Z",
    fill: "#9FADEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4806 49.1022C68.289 45.1714 76.9985 47.6159 80.7672 54.5154L81.746 56.3075C84.4112 61.1867 82.2461 67.2994 77.104 69.4132L74.9309 70.3066C69.3725 72.5916 62.9809 70.4124 59.976 65.2078L57.3267 60.6191C55.146 56.842 56.4402 52.0123 60.2172 49.8316L61.4806 49.1022Z",
    fill: "url(#paint5_linear_55_16028)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_55_16028)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.5007 55.1162C72.8814 55.1162 74.0007 54.2208 74.0007 53.1162C74.0007 52.0116 72.8814 51.1162 71.5007 51.1162C70.12 51.1162 69.0007 52.0116 69.0007 53.1162C69.0007 54.2208 70.12 55.1162 71.5007 55.1162ZM63.0007 58.1162C64.6576 58.1162 66.0007 56.9969 66.0007 55.6162C66.0007 54.2355 64.6576 53.1162 63.0007 53.1162C61.3439 53.1162 60.0007 54.2355 60.0007 55.6162C60.0007 56.9969 61.3439 58.1162 63.0007 58.1162ZM67.5007 65.9346C69.4337 65.9346 71.0007 64.5914 71.0007 62.9346C71.0007 61.2777 69.4337 59.9346 67.5007 59.9346C65.5677 59.9346 64.0007 61.2777 64.0007 62.9346C64.0007 64.5914 65.5677 65.9346 67.5007 65.9346ZM80.0007 59.6162C80.0007 60.9969 78.6576 62.1162 77.0007 62.1162C75.3439 62.1162 74.0007 60.9969 74.0007 59.6162C74.0007 58.2355 75.3439 57.1162 77.0007 57.1162C78.6576 57.1162 80.0007 58.2355 80.0007 59.6162Z",
    fill: "#556091"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6874 10.9556L67.5112 13.6389L70.8037 12.7657L68.6385 15.2972L70.4593 17.9811L67.4096 16.8817L65.5995 19.3935L65.5229 16.2026L62.6563 15.1336L65.5857 14.1985L65.6874 10.9556Z",
    fill: "white",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_55_16028",
    x: 7.89746,
    y: 9.17155,
    width: 59.9221,
    height: 60.7975,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_55_16028"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_55_16028",
    x: 29.2996,
    y: 14.1162,
    width: 11,
    height: 29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_55_16028"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_55_16028",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_55_16028"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_55_16028",
    x: 60.0007,
    y: 51.1162,
    width: 20,
    height: 15.8184,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_55_16028"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_55_16028",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_55_16028"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_55_16028",
    x1: 88,
    y1: 0.0000104904,
    x2: 0.0000104904,
    y2: 88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD684"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCA2A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_55_16028",
    x1: 18.2912,
    y1: 0.00000128686,
    x2: 69.7088,
    y2: 88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB4343"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_55_16028",
    x1: 18.2912,
    y1: 0.00000128686,
    x2: 69.7088,
    y2: 88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB4343"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_55_16028",
    x1: 34.7215,
    y1: 4.69034,
    x2: 34.7269,
    y2: 51.9546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_55_16028",
    x1: 67.5394,
    y1: 84.7082,
    x2: 67.5394,
    y2: 46.6031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1DCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9AAFED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_55_16028",
    x1: 76.7259,
    y1: 46.8373,
    x2: 61.4232,
    y2: 70.4446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgK3Round1M);
export default __webpack_public_path__ + "static/media/k3_round_1m.0db31714bd45b0adaa8d4de69173f3bd.svg";
export { ForwardRef as ReactComponent };